import React, { useCallback, useState } from 'react';
import { PiPencilSimple, PiRuler } from 'react-icons/pi';
import { GeoJson } from '@ais-ui/api-spec/shapes';
import { useAuth } from '@ais-ui/auth';
import { useMapContextMenu } from './MapContextMenuContext';
import { MenuItem } from './MenuItem';
import { ShapeAreaPopup } from './ShapeAreaPopup';

interface ShapeContextMenuItemsProps {
  shape: GeoJson;
}

export const ShapeContextMenuItems = ({
  shape,
}: ShapeContextMenuItemsProps) => {
  const { credentials } = useAuth();
  const { closeContextMenu, state, openEditShapeDialog } = useMapContextMenu();
  const [showAreaPopup, setShowAreaPopup] = useState(false);

  const isOwner = shape.properties?.owner === credentials?.username;

  // Check if shape has area-calculable geometry
  const geometryType = shape.geometry?.type;
  const isCircle = geometryType === 'Point' && shape.properties?.radius;
  const isPolygon = geometryType === 'Polygon';
  const canCalculateArea = isPolygon || isCircle;

  const handleEdit = useCallback(() => {
    openEditShapeDialog(shape);
    closeContextMenu();
  }, [closeContextMenu, openEditShapeDialog, shape]);

  const handleCalculateArea = useCallback(() => {
    setShowAreaPopup(true);
    closeContextMenu();
  }, [closeContextMenu]);

  return (
    <>
      <MenuItem disabled={!isOwner} onClick={handleEdit}>
        <PiPencilSimple className="h-4 w-4" />
        Edit Shape
      </MenuItem>

      {canCalculateArea && (
        <>
          <div className="-mx-1 my-1 h-px bg-border" />
          <MenuItem onClick={handleCalculateArea}>
            <PiRuler className="h-4 w-4" />
            Calculate Area
          </MenuItem>
        </>
      )}

      {showAreaPopup && state.position && (
        <ShapeAreaPopup
          shape={shape}
          position={state.position}
          isOwner={isOwner}
          onClose={() => setShowAreaPopup(false)}
        />
      )}
    </>
  );
};
